import { collection, onSnapshot, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { setFiles, setFolders } from './fileStorageSlice';
import type { AppDispatch } from './store';

let unsubscribeFiles: (() => void) | null = null;
let unsubscribeFolders: (() => void) | null = null;

export const subscribeFileStorage = () => (dispatch: AppDispatch) => {
  // Unsubscribe previous listeners if any
  if (unsubscribeFiles) unsubscribeFiles();
  if (unsubscribeFolders) unsubscribeFolders();

  unsubscribeFiles = onSnapshot(collection(db, 'fileStorages'), (snapshot) => {
    const files = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt && typeof data.createdAt.toMillis === 'function' ? data.createdAt.toMillis() : data.createdAt,
        updatedAt: data.updatedAt && typeof data.updatedAt.toMillis === 'function' ? data.updatedAt.toMillis() : data.updatedAt,
      };
    });
    dispatch(setFiles(files));
  });
  unsubscribeFolders = onSnapshot(collection(db, 'folderStructures'), (snapshot) => {
    const folders = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt && typeof data.createdAt.toMillis === 'function' ? data.createdAt.toMillis() : data.createdAt,
        updatedAt: data.updatedAt && typeof data.updatedAt.toMillis === 'function' ? data.updatedAt.toMillis() : data.updatedAt,
        locked: typeof data.locked === 'boolean' ? data.locked : false,
      };
    });
    dispatch(setFolders(folders));
  });
};

export const fetchFileStorageOnce = () => async (dispatch: AppDispatch) => {
  const fileSnap = await getDocs(collection(db, 'fileStorages'));
  const folderSnap = await getDocs(collection(db, 'folderStructures'));
  dispatch(setFiles(fileSnap.docs.map(doc => {
    const data = doc.data();
    return {
      id: doc.id,
      ...data,
      createdAt: data.createdAt && typeof data.createdAt.toMillis === 'function' ? data.createdAt.toMillis() : data.createdAt,
      updatedAt: data.updatedAt && typeof data.updatedAt.toMillis === 'function' ? data.updatedAt.toMillis() : data.updatedAt,
    };
  })));
  dispatch(setFolders(folderSnap.docs.map(doc => {
    const data = doc.data();
    return {
      id: doc.id,
      ...data,
      createdAt: data.createdAt && typeof data.createdAt.toMillis === 'function' ? data.createdAt.toMillis() : data.createdAt,
      updatedAt: data.updatedAt && typeof data.updatedAt.toMillis === 'function' ? data.updatedAt.toMillis() : data.updatedAt,
      locked: typeof data.locked === 'boolean' ? data.locked : false,
    };
  })));
};

export const unsubscribeFileStorage = () => {
  if (unsubscribeFiles) unsubscribeFiles();
  if (unsubscribeFolders) unsubscribeFolders();
  unsubscribeFiles = null;
  unsubscribeFolders = null;
};
